import React from 'react';
import TicketSummary from '../components/TicketSummary';
import './AdminDashboard.css'; // reuse your styles

const TicketSummaryPage = () => {
  return (
    <div className="dashboard-container">
      <h1 className="section-title">Ticket Summary Dashboard</h1>
      <TicketSummary />
    </div>
  );
};

export default TicketSummaryPage;
